import styled, { css, keyframes } from 'styled-components';
import { COLOR } from '@src/styles/color';
import { CLIP_HEIGHT } from '@src/constants/timeline';

const shimmer = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

const clipStripes = css`
  background-image: linear-gradient(
      to bottom,
      ${COLOR.white} 24%,
      rgba(255, 255, 255, 0) 100%
    ),
    repeating-linear-gradient(
      -45deg,
      ${COLOR.label[4]} 0 4.11px,
      transparent 4.11px 8.49px
    );
`;
// Same shell as StyledClip (height, 0.5px outline, 8px radius, stripe fill) so
// the placeholder lines up pixel-for-pixel with the clips it sits next to. It
// is decorative only — no pointer target, no focus, no drag.
export const StyledClipSkeleton = styled.div`
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: ${({ left }) => left}px;
  width: ${({ width }) => width}px;
  transform: translateY(-50%);
  height: ${CLIP_HEIGHT}px;
  padding: 4px 0;
  overflow: hidden;
  border: 0.5px solid ${COLOR.label[16]};
  border-radius: 8px;
  background-color: ${COLOR.white};
  ${clipStripes};
  pointer-events: none;
`;

// Stands in for the clip's text row: a rounded bar on the same 4px inset and
// 16px line box, sweeping from grey to transparent so it reads as "loading"
// rather than as an empty clip.
export const StyledTextBar = styled.span`
  display: block;
  height: 8px;
  margin: 4px;
  border-radius: 480px;
  background: linear-gradient(
    90deg,
    ${COLOR.label[16]} 25%,
    ${COLOR.label[8]} 50%,
    ${COLOR.label[16]} 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;
`;
